import { StatusEnumItem } from './StatusEnumItem'
import { StatusEnum } from './statusEnum'

const Draft = new StatusEnumItem({
  id: 'db7b5e3b-9e9e-4007-a194-8913ed4b74f3',
  name: 'Draft',
  description:
    'RFI is ready to be created, but not ready to advance through the RFI Tracker',
  priority: 0,
})
const PendingResponses = new StatusEnumItem({
  id: 'ca34f03b-c593-4e5f-9f8b-ef2d498e7a7c',
  name: 'Pending Responses',
  description: 'Each required Discipline submits a response to the RFI',
  priority: 1,
})
const Closed = new StatusEnumItem({
  id: '30d07946-b9f3-4430-802f-5cef142d7c33',
  name: 'Closed',
  description:
    'All required Disciplines have submitted and closed their response, backup documents are locked to editing',
  priority: 2,
})
const Unlocked = new StatusEnumItem({
  id: 'e7baa197-bf74-4003-aa46-cb7b413758a9',
  name: 'Unlocked',
  description: 'Backup documents are unlocked and editable',
  priority: 3,
})

export type RFIStatusItem =
  | typeof Draft
  | typeof PendingResponses
  | typeof Closed
  | typeof Unlocked

class RFIStatusEnum extends StatusEnum<
  'RFIStatus',
  RFIStatusItem,
  RFIStatusItem['name'],
  RFIStatusItem['id'],
  RFIStatusItem['priority']
> {
  readonly typename = 'RFIStatus'
  get values() {
    return [this.Draft, this.PendingResponses, this.Closed, this.Unlocked]
  }
  readonly Draft = Draft
  readonly PendingResponses = PendingResponses
  readonly Closed = Closed
  readonly Unlocked = Unlocked
}

export const RFIStatus = new RFIStatusEnum()
